"use client";

import { useState } from "react";
import Link from "next/link";
import { ignoreRefusal, requestJson } from "@/lib/clientRequest";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setSubmitting(true);
    try {
      await requestJson("/api/auth/forgot", {
        method: "POST",
        body: { email },
      }).catch(ignoreRefusal);
    } finally {
      setDone(true);
      setSubmitting(false);
    }
  }

  return (
    <div className="flex min-h-dvh items-center justify-center bg-zinc-950 px-4 py-12">
      <div className="w-full max-w-sm space-y-8">
        <div className="space-y-2 text-center">
          <div className="mx-auto flex size-12 items-center justify-center rounded-2xl bg-violet-600 text-lg font-bold text-white">
            W
          </div>
          <h1 className="text-2xl font-semibold tracking-tight text-zinc-100">
            Reset password
          </h1>
          <p className="text-sm text-zinc-400">
            Enter your email and we&apos;ll send a reset link.
          </p>
        </div>

        {done ? (
          <p className="rounded-lg border border-emerald-500/30 bg-emerald-500/10 px-3 py-3 text-center text-sm text-emerald-300">
            If that account exists, a reset link is on its way.
          </p>
        ) : (
          <form onSubmit={onSubmit} className="space-y-4">
            <input
              type="email"
              required
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              className="w-full rounded-lg border border-zinc-700 bg-zinc-950 px-3 py-2.5 text-base sm:text-sm text-zinc-100 outline-none transition focus:border-violet-500/60"
            />
            <button
              type="submit"
              disabled={submitting}
              className="w-full rounded-lg bg-violet-600 px-4 py-2.5 text-sm font-medium text-white transition hover:bg-violet-500 disabled:opacity-60"
            >
              {submitting ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}

        <p className="text-center text-sm text-zinc-500">
          <Link href="/login" className="text-violet-300 hover:underline">
            Back to sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
